import Backend from 'backend';
import {customElement, bindable, bindingMode, observable} from 'aurelia-framework';
import {inject} from 'aurelia-framework';
import {ValidationController, ValidationRules} from "aurelia-validation";

@customElement('create-delivery-note-component')
@inject(Backend, Element, ValidationController)
export class CreateDeliveryNoteComponent {
  backend;
  element;
  validationController;

  @bindable()
  orderId;

  createdDeliveryNoteId;

  commandTemplate = {lines: []};

  constructor(backend, element, validationController) {
    this.backend = backend;
    this.element = element;
    this.validationController = validationController;
  }

  bind() {
    // Set up initial validation. Don't wait to run this. Validation should be enabled before the command template
    // is loaded from api.
    this.refreshValidationRules();
  }

  changeSelectedPrefillSource(selectedPrefillSource) {
    this.backend.CreateDeliveryNoteCommandHandler_getTemplate({orderDocumentType: selectedPrefillSource.orderDocumentType, id: selectedPrefillSource.id})
      .then(result => {
        // Store result
        this.commandTemplate = result.command;

        this.refreshValidationRules();
      });
  }

  refreshValidationRules() {
    // Add validation to result
    ValidationRules
      .ensure('deliveryDate')
      .displayName('Leveringsdato')
      .required()
      .on(this.commandTemplate);

    // Add validation to result's lines
    for (const line of this.commandTemplate.lines) {
      ValidationRules
        .ensure('deliveredQuantity')
        .displayName('Levert antall')
        .required()
        .then()
        .satisfies(value => Number.isInteger(Number(value))) // Number() converts string to number. Otherwise "1" is not an integer.
        .withMessage('Levert antall må være et heltall')
        .on(line);
    }
  }

  saveButtonClicked() {
    return this._save()
          .then(deliveryNoteId => {
            // Don't do this on saveAndSend because we don't want to show the send button while we're in progress (risk of double click)
            this.createdDeliveryNoteId = deliveryNoteId;
          });
  }

  sendButtonClicked() {
    return this._send(this.createdDeliveryNoteId);
  }

  saveAndSendButtonClicked() {
    return this._save()
      .then(deliveryNoteId => {
        // Only try to send if delivery note was created (may not have passed validation).
        if (deliveryNoteId) {
          this._send(deliveryNoteId);
        }
      });
  }

  closeButtonClicked() {
    this.emitDoneEvent(this.createdDeliveryNoteId);
  }

  _save() {
    return this.validationController.validate()
      .then(result => {
        if (!result.valid) {
          return;
        }

        return this.backend.CreateDeliveryNoteCommandHandler_handle({
          orderId: this.commandTemplate.orderId,
          deliveryDate: this.commandTemplate.deliveryDate,
          newAdditionalFields: [],
          lines: this.commandTemplate.lines.map(line => ({
            orderLineId: line.orderLineId,
            deliveredQuantity: line.deliveredQuantity,
            newAdditionalFields: line.newAdditionalFields,
          }))
        })
      });
  }

  _send(deliveryNoteId) {
    return this.backend.SendDeliveryNoteCommandHandler_handle({deliveryNoteId: deliveryNoteId})
      .then(() => this.emitDoneEvent(deliveryNoteId));
  }

  emitDoneEvent(deliveryNoteId) {
    this.element.dispatchEvent(new CustomEvent('done', {
      detail: {deliveryNoteId: deliveryNoteId},
      bubbles: true
    }));

    // Clear form for reuse
    this.createdDeliveryNoteId = null;
  }
}
